import React from 'react';
import { createSvgIcon } from '@material-ui/core';

export default createSvgIcon(
  <path d="M11.9999 1.92001C6.43352 1.92001 1.91992 6.43361 1.91992 12C1.91992 17.5664 6.43352 22.08 11.9999 22.08C17.5663 22.08 22.0799 17.5664 22.0799 12C22.0799 6.43361 17.5663 1.92001 11.9999 1.92001ZM16.1999 15.64H7.79992L5.69992 10.04L8.96752 11.44L11.9999 7.24001L15.0323 11.44L18.2999 10.04L16.1999 15.64Z" />,
  'Crown'
);
